import { createReducer, on } from '@ngrx/store';

import { SubscriptionActions } from '../company/subscription/subscription-state.actions';

import { BillingStateActions } from './billing-state.actions';
import { BillingState, InitialBillingState } from './billing-state.model';

export const BillingStateReducer = createReducer<BillingState>(
  InitialBillingState,
  on(
    BillingStateActions.getCompanyBillingCountsSuccess,
    BillingStateActions.getBillingCountsAfterStripeRedirectSuccess,
    (state, { companyBillingCounts }): BillingState => ({
      ...state,
      companyBillingCounts,
    })
  ),
  on(
    BillingStateActions.getUpcomingInvoiceSuccess,
    (state, { invoice }): BillingState => ({
      ...state,
      upcomingInvoice: invoice,
    })
  ),
  on(
    BillingStateActions.getCurrentSubscriptionConfigSuccess,
    (state, { currentSubscriptionConfig }): BillingState => ({
      ...state,
      currentSubscriptionConfig,
    })
  ),
  on(
    BillingStateActions.getFutureSubscriptionConfigSuccess,
    BillingStateActions.getFutureSubscriptionConfigAfterDowngradeSuccess,
    (state, { futureSubscriptionConfig }): BillingState => ({
      ...state,
      futureSubscriptionConfig,
    })
  ),
  on(
    BillingStateActions.renewSubscriptionSuccess,
    (state): BillingState => ({
      ...state,
      futureSubscriptionConfig: null,
    })
  ),
  on(
    BillingStateActions.getCommercialModelSubscriptionsSuccess,
    (state, { pricingPlans }): BillingState => ({
      ...state,
      pricingPlans,
    })
  ),
  on(
    SubscriptionActions.getUpdatedSubscriptionAfterPlanChangeSuccess,
    (state, { configId }): BillingState => ({
      ...state,
      upgradedSuccessfully: !!configId,
    })
  ),
  on(
    BillingStateActions.dismissUpdatedSubscriptionNotification,
    (state): BillingState => ({
      ...state,
      upgradedSuccessfully: false,
    })
  )
);
